'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// C:/GH/1106/advice.noa.origination/~/get-proto/Reflect.getPrototypeOf.js
// module id = 255
// module chunks = 0